/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    take, put, fork, select,
    call,
} from 'redux-saga/effects';
import Cookies from 'universal-cookie';
import mbpLogger from 'mbp-logger';
import {
    recordPaymentMethodType,
    recordPaymentMethodTypeCompleted,
} from '../Payment/Payment-Actions';
import { applyPromotion, promotionSuccess } from '../Payment/Promotions/Promotion-Actions';
import {
    attributionApplyPromo,
    attributionApplyPromoCompleted,
    attributionApplyPromoLinkedPaymentMethod,
    attributionApplyPromoLinkedPaymentMethodCompleted,
    logBannerCodeTried,
} from './Attribution-Actions';
import takeLeading from '../../../../../app/helpers/sagas/takeLeading';
import { getIsBannerCodeTried } from './Attribution-Selectors';
import { workerApplyPromotion } from '../Payment/Promotions/Promotion-Operations';
import updateAttribute from '../../../../../apis/cart-service-apis/updateAttribute';
import { getOrderId } from '../Cart/Cart-Selectors';
import { checkJWT } from '../../../Member/ducks/Auth/Auth-Operations';

const parseBannerCookie = () => {
    const cookies = new Cookies();
    const bCookie = cookies.get('banner');

    if (bCookie) {
        const bAttr = JSON.parse(JSON.stringify(bCookie));

        mbpLogger.logInfo({
            bCookie,
            function: 'parseBannerCookie',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout :: checkout',
            message: 'Parsed banner cookie for order upload',
        });

        return bAttr;
    }

    return '';
};

export function* workerAttributionApplyPromoCode() {
    try {
        const isBannerCookieTried = yield select(getIsBannerCodeTried);

        // Applies the promotion set in the cookie
        // promo is not applied if prmomo is associated to payment method
        // bannerObj?.mp has the payment method type eg: PayPal
        const bannerObj = parseBannerCookie();

        if (
            !isBannerCookieTried && bannerObj && bannerObj.p
            && (!bannerObj.mp || bannerObj.mp === 'CreditCard')
        ) {
            const payload = {
                promotionCode: bannerObj.p,
                membershipId: '',
                pageType: 'payment',
                history: '',
                reason: 'attribution',
            };

            yield fork(workerApplyPromotion, { payload });
            yield take(promotionSuccess().type);

            yield put(logBannerCodeTried(true));
        }
    } catch (ex) {
        mbpLogger.logError({
            function: 'workerAttributionApplyPromoCode',
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            message: 'Failed - workerAttributionApplyPromoCode',
            jsError: ex,
        });
    }

    yield put(attributionApplyPromoCompleted());
}

function* watcherAttributionApplyPromoCode() {
    yield takeLeading(attributionApplyPromo().type, workerAttributionApplyPromoCode);
}

function* workerAttributionApplyPromoCodeLinkedPaymentMethod(action) {
    try {
        const {
            supportedPaymentMethods,
        } = action.data;

        const bannerObj = parseBannerCookie();
        const cookiePaymentMethod = bannerObj?.mp || '';

        yield put(recordPaymentMethodType());
        yield take(recordPaymentMethodTypeCompleted().type);

        // Applies Promo for promo linked to payment method
        // bannerObj?.mp contains the payment method type eg: PayPal
        if (
            bannerObj
            && bannerObj.p
            && cookiePaymentMethod
            && supportedPaymentMethods.includes(cookiePaymentMethod)
        ) {
            const payload = {
                promotionCode: bannerObj.p,
                membershipId: '',
                pageType: 'payment',
                history: '',
            };

            yield fork(applyPromotion, { payload });
            yield take(promotionSuccess().type);

            yield put(logBannerCodeTried(true));
        }
    } catch (ex) {
        mbpLogger.logError({
            function: 'workerApplyPromoCodeLinkedPaymentMethod',
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            message: 'Failed - workerApplyPromoCodeLinkedPaymentMethod',
            jsError: ex,
        });
    }

    yield put(attributionApplyPromoLinkedPaymentMethodCompleted());
}

function* watcherAttributionApplyPromoCodeLinkedPaymentMethod() {
    yield takeLeading(attributionApplyPromoLinkedPaymentMethod().type, workerAttributionApplyPromoCodeLinkedPaymentMethod);
}

function* workerCartAttributes() {
    const cartId = yield select(getOrderId);
    const jwtToken = yield call(checkJWT);

    try {
        const attributes = [];

        if (typeof window !== 'undefined' && window?.sessionStorage?.session_fs_url) {
            attributes.push(
                {
                    attributeName: 'fsSessionUrl',
                    attributeValue: window.sessionStorage.session_fs_url,
                },
            );
        }

        if (attributes.length > 0 && cartId) {
            yield call(updateAttribute, {
                cartId,
                jwtToken,
                attributes,
            });
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'Attribution-Operations.js',
            function: 'workerCartAttributes',
            jsError: ex,
            errorMessage: ex.response,
            message: `Cart Level Extra Attributes Failed - ${cartId} - Error occured while adding extra attributes Ex: `,
        });
    }
}

const watchers = [
    fork(watcherAttributionApplyPromoCodeLinkedPaymentMethod),
    fork(watcherAttributionApplyPromoCode),
];

export {
    watchers,
    workerCartAttributes,
};

export default {};
